import { logEvent } from '../analytics/firAnalytics'

export type AppError = {
  message: string
  code?: string | number
  details?: unknown
}

/**
 * Handle an auth-related errors
 *
 * @param analyticsTag   Event name from ANALYTICS_TAGS
 * @param error          Unknown error thrown/caught
 * @param context        Where the error happened
 * @param extraParams    Any additional key/value pairs to include
 * @returns              Normalized error object
 */
export const handleAuthError = (
  analyticsTag: string,
  error: unknown,
  context: string,
  extraParams: Record<string, unknown> = {}
): AppError => {
  const normalized = normalizeError(error)

  logEvent(analyticsTag, {
    error: normalized,
    context,
    product: 'web',
    ...extraParams,
  })

  console.error(`[Auth Error – ${context}]`, error)
  return normalized
}

export const normalizeError = (err: unknown): AppError => ({
  message: err instanceof Error ? err.message : String(err),
  code:
    err instanceof Error && 'code' in err ? (err.code as string | number) : undefined,
  details: err,
})
